import React, { useEffect, useState } from "react";
import "../../CSS/ItemMaster.css";
import axios from "axios";
import LoadingScreen from "../LoadingScreen";
import { FaArrowLeft } from "react-icons/fa";
import moment from "moment";
import { useSelector } from "react-redux";
import Select from "react-select";
import AllPagesNavbar from "../../Components/MasterNavbar/AllPagesMasterNavbar";
import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { BsFileEarmarkPdf } from "react-icons/bs";
import { RiFileExcel2Line } from "react-icons/ri";

const VehiclesInWorkshopAndJobsOpen = () => {
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessionToken = window.sessionStorage.getItem("session-token");
  const [isloading, setisloading] = useState(true);
  const [search, setSearch] = useState("");
  const state = useSelector((state) => state.changeTheState.user);
  const user = state.emailId?.split("@")[0]?.toUpperCase();
  const [vehiclesList, setVehiclesList] = useState([]);
  const [showGateIn, setShowGateIn] = useState(false);
  const [date, setDate] = useState(new Date().toISOString());
  const [vehicleNo, setVehicleNo] = useState("");
  const [jobId, setJobId] = useState("");
  const [jobOpenDate, setJobOpenDate] = useState("");
  const [jobOpenTime, setJobOpenTime] = useState(
    new Date().toLocaleTimeString(),
  );
  const [problemsReported, setProblemsReported] = useState("");

  const [taskName, setTaskName] = useState("");
  const [taskId, setTaskId] = useState("");
  const [taskStatus, setTaskStatus] = useState("");

  const [jobTasksList, setJobTaskList] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [taskList, setTaskList] = useState([]);

  const [closeDate, setCloseDate] = useState(new Date().toISOString());
  const [closeTime, setCloseTime] = useState("");
  const [closeNarration, setCloseNarration] = useState("");
  const [showClosePopUp, setShowClosePopUp] = useState(false);

  const [driversList, setDriversList] = useState([]);
  const [driverName, setDriverName] = useState("");
  const [proceedToState, setProceedToState] = useState("");
  const [proceedToStateValue, setProceedToStateValue] = useState("");
  const [loadedOrEmpty, setLoadedOrEmpty] = useState("");
  const [isLoadedOrEmpty, setIsLoadedOrEmpty] = useState(false);

  const [jobIdOP, setJobIdOP] = useState("");
  const [jobOpenDateOP, setJobOpenDateOP] = useState(new Date().toISOString());
  const [jobOpenTimeOP, setJobOpenTimeOP] = useState(
    new Date().toLocaleTimeString(),
  );
  const [problemsReportedOP, setProblemsReportedOP] = useState("");

  const [taskNameOP, setTaskNameOP] = useState("");
  const [taskIdOP, setTaskIdOP] = useState("");
  const [taskStatusOP, setTaskStatusOP] = useState("");

  const [jobTasksListOP, setJobTaskListOP] = useState([]);
  const [showTableOP, setShowTableOP] = useState(false);
  const [selectedRowIndexOP, setSelectedRowIndexOP] = useState(null);
  const [taskListOP, setTaskListOP] = useState([]);

  const [currentTimeOP, setCurrentTimeOP] = useState(
    new Date().toLocaleTimeString(),
  );
  const [driversListOP, setDriversListOP] = useState([]);
  const [driverNameOP, setDriverNameOP] = useState("");
  const [vehiclesListOP, setVehiclesListOP] = useState([]);
  const [showGateInOP, setShowGateInOP] = useState(false);
  const [dateOP, setDateOP] = useState(new Date().toISOString());
  const [vehicleNoOP, setVehicleNoOP] = useState("");
  const [wbData, setWbData] = useState([]);
  const [wbName, setWbName] = useState("");
  const [wbNo, setWbNo] = useState("");
  const [WeighBridgeData, setWeighBridgeData] = useState([]);
  const [noOfVehicles, setNoOfVehicles] = useState("");

  const [selTaskOP, setSelTaskOP] = useState([]);
  const [taskOptions, setTaskOptions] = useState([]);

  const [openedOrClosed, setOpenedOrClosed] = useState("");
  const [histData, setHistData] = useState([]);
  const [showHist, setShowhist] = useState(false);
  const [searchHist, setSearchHist] = useState("");
  const [startDateHist, setStartDateHist] = useState("");
  const [endDateHist, setEndDateHist] = useState("");
  const [gateInNarration, setGateInNarration] = useState("");
  const [hist, setHist] = useState(false);

  const [currentTime, setCurrentTime] = useState(
    new Date().toLocaleTimeString(),
  );

  const VehicleDepartment = useSelector(
    (state) => state?.VehicleDepartmentReducer,
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date().toLocaleTimeString());
      setCloseTime(new Date().toLocaleTimeString());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTimeOP(new Date().toLocaleTimeString());
      setJobOpenTimeOP(new Date().toLocaleTimeString());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const filteredData = vehiclesList.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0 && !openedOrClosed) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        "VEHICLE REG NO",
        "DRIVERNAME",
        "MAKE",
        "MODEL",
        "TRAILER NAME ATTACHED",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    let openClose = true;
    if (openedOrClosed === "OPENED") {
      openClose = item.VEHICLESTATE === "JOB IN WORKSHOP";
    } else if (openedOrClosed === "CLOSED") {
      openClose = item.VEHICLESTATE === "SENT TO WORKSHOP";
    }

    return textMatch && openClose;
  });

  // Filtered Hist Data
  const filtHist = histData?.filter((item) => {
    const searchData = searchHist?.toLowerCase().split(" ").filter(Boolean);
    const sDate = new Date(item.OT_JOB_OPEN_DATE);
    const eDate = new Date(item.OT_JOB_OPEN_DATE);
    const startDate = startDateHist ? new Date(startDateHist) : null;
    const endDate = endDateHist ? new Date(endDateHist) : null;

    const textMatch = searchData.every((term) => {
      return ["OT_JOB_ID", "OT_JOB_VEHICLE", "OT_JOB_PROBLEMS_REPORTED"].some(
        (key) => {
          const columnValue = String(item[key]).toLowerCase();
          return columnValue.includes(term);
        },
      );
    });

    const dateMatch =
      (!startDate || sDate >= startDate) && (!endDate || eDate <= endDate);

    return textMatch && dateMatch;
  });

  useEffect(() => {
    initialData();
  }, []);

  const initialData = () => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1080`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setJobIdOP(response?.data[0]?.NEW_JOB_ID);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Charges details:", error);
      });

    // Task List
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1097`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setTaskList(response?.data);
        // setTaskListOP(response?.data);

        const list = response?.data?.map((item) => ({
          value: item.OM_ACTION_NAME,
          label: item.OM_ACTION_NAME,
        }));
        setTaskOptions(list);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Task List:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1264`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setWbData(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching WeighBridge details:", error);
      });

    // axios
    //   .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1060`, {
    //     headers: {
    //       "auth-token": authToken,
    //       "session-token": sessionToken,
    //     },
    //   })
    //   .then((response) => {
    //     const filterData = response?.data?.filter(
    //       (item) =>
    //         item.OT_VERIFICATION_PROCEED_TO_STATE === "SENT FOR WEIGHBRIDGE",
    //     );
    //     setWeighBridgeData(filterData);
    //   })
    //   .catch((error) => {
    //     setisloading(false);
    //     console.error("Error fetching Driver details:", error);
    //   });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=671`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        if (VehicleDepartment !== "") {
          const filterWeighbridge = response?.data?.filter(
            (item) =>
              item.VEHICLESTATE === "SENT FOR WEIGHBRIDGE" &&
              item?.DEPARTMENT === VehicleDepartment,
          );
          setWeighBridgeData(filterWeighbridge);
        } else {
          const filterWeighbridge = response?.data?.filter(
            (item) => item.VEHICLESTATE === "SENT FOR WEIGHBRIDGE",
          );
          setWeighBridgeData(filterWeighbridge);
        }
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Charges details:", error);
      });

    // Driver's List  345;
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=345`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setDriversList(response?.data);
        setDriversListOP(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Driver details:", error);
      });

    // Historical Data - 1081;
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1081`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const sortedData = response.data.sort(
          (a, b) => a.OT_JOB_ID - b.OT_JOB_ID,
        );
        setHistData(sortedData);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching 1081 details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1319`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        if (VehicleDepartment !== "") {
          const filterData = response?.data?.filter(
            (item) =>
              item.VEHICLESTATE === "JOB IN WORKSHOP" ||
              (item?.VEHICLESTATE === "SENT TO WORKSHOP" &&
                item?.DEPARTMENT === VehicleDepartment),
          );
          setVehiclesList(filterData);
        } else {
          const filterData = response?.data?.filter(
            (item) =>
              item.VEHICLESTATE === "JOB IN WORKSHOP" ||
              item?.VEHICLESTATE === "SENT TO WORKSHOP",
          );
          setVehiclesList(filterData);
        }
        setisloading(false);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Charges details:", error);
      });
  };

  function getJobDetails(vehicle) {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1081`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const filterData = response?.data?.filter(
          (item) =>
            item.OT_JOB_VEHICLE === vehicle && item.OT_JOB_STATUS === "OPEN",
        );
        setJobId(filterData[0]?.OT_JOB_ID);
        setVehicleNo(filterData[0]?.OT_JOB_VEHICLE);
        setJobOpenDate(filterData[0]?.OT_JOB_OPEN_DATE);
        setJobOpenTime(filterData[0]?.OT_JOB_OPEN_TIME);
        setProblemsReported(filterData[0]?.OT_JOB_PROBLEMS_REPORTED);
        setIsLoadedOrEmpty(
          filterData[0]?.OT_JOB_TRUCK_LOADED_EMPTY === "LOADED" ? true : false,
        );
        if (filterData[0]?.OT_JOB_TRUCK_LOADED_EMPTY === "LOADED") {
          setProceedToState("PROCEED TO GATE OUT");
          setProceedToStateValue("DISPATCHED");
        }
        fetchJobs(filterData[0]?.OT_JOB_ID);
        setisloading(false);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Charges details:", error);
      });
  }

  function getGateInNarration(vehicle) {
    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=1056&OT_GATE_IN_VEHICLE=${vehicle}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      )
      .then((response) => {
        const sortedData = response.data.sort(
          (a, b) => b.OT_GATE_NO - a.OT_GATE_NO,
        );
        setGateInNarration(
          sortedData?.length > 0 ? sortedData[0]?.OT_GATE_IN_COMMENT : "",
        );
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching 1081 details:", error);
      });
  }

  function fetchJobs(job) {
    if (job) {
      axios
        .get(
          `${BASEURL_GLOBAL}/globalViewHandler?viewname=1084&OT_JOB_ID=${job}`,
          {
            headers: {
              "auth-token": authToken,
              "session-token": sessionToken,
            },
          },
        )
        .then((response) => {
          setJobTaskList(response?.data);
          setShowTable(true);
          setisloading(false);
        })
        .catch((error) => {
          setisloading(false);
          console.error("Error fetching Charges details:", error);
        });
    }
  }

  // Saving
  async function SaveGateIn() {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1082`,
        {
          OT_JOB_ID: Number(jobId),
          OT_JOB_VEHICLE: vehicleNo,
          OT_JOB_OPEN_DATE: moment(jobOpenDate).format("YYYY/MM/DD"),
          OT_JOB_OPEN_TIME: jobOpenTime,
          OT_JOB_OPEN_BY: user,
          OT_JOB_PROBLEMS_REPORTED: problemsReported,
          OT_JOB_STATUS: "CLOSED",
          OT_JOB_CLOSED_DATE: moment(closeDate).format("YYYY/MM/DD"),
          OT_JOB_CLOSED_TIME: closeTime,
          OT_JOB_CLOSED_BY: user,
          OT_JOB_CLOSED_NARRATION: closeNarration,
          OT_JOB_STATUS_PROCEED_TO: proceedToStateValue
            ? proceedToStateValue
            : "",
          OT_JOB_STATUS_PROCEED_TO_WEIGHBRIDGE_NUMBER: wbNo ? Number(wbNo) : 0,
          OT_JOB_TRUCK_LOADED_EMPTY:
            isLoadedOrEmpty === true ? "LOADED" : "EMPTY",
          OT_JOB_NEW_EXISTING: "EXISTING",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        // setisloading(false);
        // console.log(`Job Header Saved successfully`);
        await SaveTasks(response?.data?.message);
      } else {
        setisloading(false);
        console.error(`Error while saving Job Header`);
        alert(`Error while saving Job Header`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving Job Header`, error);
      alert(`Error while saving Job Header`, error);
    }
  }

  async function SaveTasks(docNo) {
    setisloading(true);
    let successCount = 0;
    let successMessage = null;
    let errorCount = 0;
    let errorMessage = null;
    for (let index = 0; index < jobTasksList.length; index++) {
      const value = jobTasksList[index];
      try {
        const response = await axios.post(
          `${BASEURL_GLOBAL}/globalSpHandler?spname=1083`,
          {
            OT_JOB_ID: Number(docNo),
            OT_JOB_TASK_ID: Number(value?.OT_JOB_TASK_ID),
            OT_JOB_TASK_STATUS: value.OT_JOB_TASK_STATUS,
            OT_JOB_TASK_STATUS_UPDATED_BY: user,
            OT_JOB_TASK_START_DATE: moment(date).format("YYYY/MM/DD"),
            OT_JOB_TASK_START_DATE_UPDATED_BY: user,
            OT_JOB_TASK_END_DATE: moment(closeDate).format("YYYY/MM/DD"),
            OT_JOB_TASK_END_DATE_UPDATED_BY: user,
          },
          {
            headers: {
              "auth-token": authToken,
              "session-token": sessionToken,
            },
          },
        );

        if (response.status === 201) {
          successCount++;
          successMessage = response.data.message;
        } else {
          errorCount++;
          errorMessage = response.data.message;
        }
      } catch (error) {
        setisloading(false);
        console.error(`Error while Saving Tasks`, error);
        alert(error.response.data.message);
      }
    }
    setisloading(false);
    if (successCount == jobTasksList.length && successMessage) {
      //   alert(successMessage);
      await SaveVehicleState(docNo);
      // alert("Tasks for the Job Closed Successfully");
    }
    if (errorMessage) {
      alert(errorMessage);
    }
  }

  async function SaveVehicleState(docNo) {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1053`,
        {
          OT_VEHICLE_REG_NO: vehicleNo,
          OT_VEHICLE_STATE:
            isLoadedOrEmpty === true
              ? "DISPATCHED"
              : proceedToStateValue
                ? proceedToStateValue
                : "JOB CLOSED",
          OT_VEHICLE_STATE_DATE: moment(date).format("YYYY/MM/DD"),
          OT_VEHICLE_STATE_TIME: currentTime,
          OT_VEHICLE_PREVIOUS_STATE: "JOB IN WORKSHOP",
          OT_VEHICLE_STATE_UPDATED_BY: user,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        await SaveState(docNo);

        // setisloading(false);
        // alert(`Vehicle State Updated successfully`);
        console.log(`Vehicle State Updated successfully`);
      } else {
        setisloading(false);
        alert(`Error while saving Vehicle State`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving Vehicle State `, error);
      alert(`Error while saving Vehicle State `, error);
    }
  }

  async function SaveState(docNo) {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1121`,
        {
          TRANSTYPE: "JOB CLOSED",
          DOC_NO: Number(docNo),
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        setisloading(false);
        alert(`Job Closed successfully`);
        // alert(`State Updated successfully`);
        console.log(`State Updated successfully`);
      } else {
        setisloading(false);
        console.error(`Error while saving State`);
        alert(`Error while saving State`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving State `, error);
      alert(`Error while saving State `, error);
    }
  }

  // **************************************** Adding Items To Grid ********************************
  const AddItemsToGrid = () => {
    if (!taskName) {
      alert("Please select Task");
    } else if (!taskStatus) {
      alert("Kindly Provide the Task Status");
    } else {
      const newItem = {
        OT_JOB_TASK_ID: taskId,
        OT_JOB_TASK_NAME: taskName,
        OT_JOB_TASK_STATUS: taskStatus,
      };
      const existingRowIndex = jobTasksList.findIndex(
        (charge) => charge.OT_JOB_TASK_ID === newItem.OT_JOB_TASK_ID,
      );

      if (existingRowIndex !== -1) {
        const updatedItems = [...jobTasksList];
        updatedItems[existingRowIndex] = newItem;
        setJobTaskList(updatedItems);
      } else {
        setJobTaskList([...jobTasksList, newItem]);
      }

      setShowTable(true);
      clearallinputs();
    }
  };

  const clearallinputs = () => {
    setSelectedRowIndex(null);
    setTaskName("");
    setTaskId("");
    setTaskStatus("");
  };

  const RemoveItems = () => {
    const updatedValues = [...jobTasksList];
    if (updatedValues.length === 0) {
      alert("There is no Tasks to be removed");
      setShowTable(false);
    } else {
      if (
        selectedRowIndex !== null &&
        selectedRowIndex >= 0 &&
        selectedRowIndex < updatedValues.length
      ) {
        updatedValues.splice(selectedRowIndex, 1);
        setSelectedRowIndex(null);
      } else {
        updatedValues.pop();
      }
      setJobTaskList(updatedValues);
      clearallinputs();
      if (updatedValues.length === 0) {
        setShowTable(false);
      }
    }
  };

  const handleRowClick = (value, index) => {
    setDriverName(value["DRIVERNAME"]);
    setVehicleNo(value["VEHICLE REG NO"]);
    getJobDetails(value["VEHICLE REG NO"]);
    setShowGateIn(true);
  };

  // **************************************** Adding Items To Grid OP ********************************
  const AddItemsToGridOP = () => {
    if (!taskNameOP) {
      alert("Please select Task");
    } else if (!taskStatusOP) {
      alert("Kindly Provide the Task Status");
    } else {
      const newItem = {
        OT_JOB_TASK_ID: taskIdOP,
        OT_JOB_TASK_NAME: taskNameOP,
        OT_JOB_TASK_STATUS: taskStatusOP,
      };
      const existingRowIndex = jobTasksListOP.findIndex(
        (charge) => charge.OT_JOB_TASK_ID === newItem.OT_JOB_TASK_ID,
      );

      if (existingRowIndex !== -1) {
        const updatedItems = [...jobTasksListOP];
        updatedItems[existingRowIndex] = newItem;
        setJobTaskListOP(updatedItems);
      } else {
        setJobTaskListOP([...jobTasksListOP, newItem]);
      }

      setShowTableOP(true);
      clearallinputsOP();
    }
  };

  const clearallinputsOP = () => {
    setSelectedRowIndexOP(null);
    setTaskNameOP("");
    setTaskIdOP("");
    setTaskStatusOP("");
  };

  const RemoveItemsOP = () => {
    const updatedValues = [...jobTasksListOP];
    if (updatedValues.length === 0) {
      alert("There is no Tasks to be removed");
      setShowTableOP(false);
    } else {
      if (
        selectedRowIndexOP !== null &&
        selectedRowIndexOP >= 0 &&
        selectedRowIndexOP < updatedValues.length
      ) {
        updatedValues.splice(selectedRowIndexOP, 1);
        setSelectedRowIndexOP(null);
      } else {
        updatedValues.pop();
      }
      setJobTaskListOP(updatedValues);
      clearallinputsOP();
      if (updatedValues.length === 0) {
        setShowTableOP(false);
      }
    }
  };

  const handleRowClickOP = (value, index) => {
    setDriverNameOP(value["DRIVERNAME"]);
    setVehicleNoOP(value["VEHICLE REG NO"]);
    getGateInNarration(value["VEHICLE REG NO"]);
    setShowGateInOP(true);
  };

  // ************************** SAVING OP ********************************

  // Saving
  async function SaveGateInOP() {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1082`,
        {
          OT_JOB_ID: Number(jobIdOP),
          OT_JOB_VEHICLE: vehicleNoOP,
          OT_JOB_OPEN_DATE: moment(jobOpenDateOP).format("YYYY/MM/DD"),
          OT_JOB_OPEN_TIME: jobOpenTimeOP,
          OT_JOB_OPEN_BY: user,
          OT_JOB_PROBLEMS_REPORTED: problemsReportedOP,
          OT_JOB_STATUS: "OPEN",
          OT_JOB_CLOSED_DATE: "",
          OT_JOB_CLOSED_TIME: "",
          OT_JOB_CLOSED_BY: "",
          OT_JOB_CLOSED_NARRATION: "",
          OT_JOB_STATUS_PROCEED_TO: proceedToStateValue
            ? proceedToStateValue
            : "",
          OT_JOB_STATUS_PROCEED_TO_WEIGHBRIDGE_NUMBER: wbNo ? Number(wbNo) : 0,
          OT_JOB_TRUCK_LOADED_EMPTY: loadedOrEmpty,
          OT_JOB_NEW_EXISTING: hist === true ? "EXISTING" : "NEW",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        // setisloading(false);
        // console.log(`Job Header Saved successfully`);
        await SaveTasksOP(response?.data?.message);
      } else {
        setisloading(false);
        console.error(`Error while saving Job Header`);
        alert(`Error while saving Job Header`);
      }
    } catch (error) {
      setisloading(false);
      alert(`Error while saving Job Header`, error);
      console.error(`Error while saving Job Header`, error);
    }
  }

  async function SaveTasksOP(docNo) {
    setisloading(true);
    let successCount = 0;
    let successMessage = null;
    let errorCount = 0;
    let errorMessage = null;
    for (let index = 0; index < selTaskOP.length; index++) {
      const value = selTaskOP[index];
      try {
        const response = await axios.post(
          `${BASEURL_GLOBAL}/globalSpHandler?spname=1083`,
          {
            OT_JOB_ID: Number(docNo),
            OT_JOB_TASK_ID: 0,
            OT_JOB_TASK_STATUS: value,
            OT_JOB_TASK_STATUS_UPDATED_BY: user,
            OT_JOB_TASK_START_DATE: moment(dateOP).format("YYYY/MM/DD"),
            OT_JOB_TASK_START_DATE_UPDATED_BY: user,
            OT_JOB_TASK_END_DATE: "",
            OT_JOB_TASK_END_DATE_UPDATED_BY: "",
          },
          {
            headers: {
              "auth-token": authToken,
              "session-token": sessionToken,
            },
          },
        );

        if (response.status === 201) {
          successCount++;
          successMessage = response.data.message;
        } else {
          errorCount++;
          errorMessage = response.data.message;
        }
      } catch (error) {
        setisloading(false);
        console.error(`Error while Saving Tasks`, error);
        alert(error.response.data.message);
      }
    }
    setisloading(false);
    if (successCount == selTaskOP.length && successMessage) {
      //   alert(successMessage);
      await SaveVehicleStateOP(docNo);
      // alert("Tasks for the Job Saved Successfully");
    }
    if (errorMessage) {
      alert(errorMessage);
    }
  }

  async function SaveVehicleStateOP(docNo) {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1053`,
        {
          OT_VEHICLE_REG_NO: vehicleNoOP,
          OT_VEHICLE_STATE: "JOB IN WORKSHOP",
          OT_VEHICLE_STATE_DATE: moment(dateOP).format("YYYY/MM/DD"),
          OT_VEHICLE_STATE_TIME: currentTimeOP,
          OT_VEHICLE_PREVIOUS_STATE: "SENT TO WORKSHOP",
          OT_VEHICLE_STATE_UPDATED_BY: user,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        // setisloading(false);
        await SaveStateOP(docNo);
        // alert(`Vehicle State Updated successfully`);
        console.log(`Vehicle State Updated successfully`);
      } else {
        setisloading(false);
        console.error(`Error while saving Vehicle State`);
        alert(`Error while saving Vehicle State`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving Vehicle State `, error);
      alert(`Error while saving Vehicle State `, error);
    }
  }

  async function SaveStateOP(docNo) {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1121`,
        {
          TRANSTYPE: "JOB IN WORKSHOP",
          DOC_NO: Number(docNo),
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        setisloading(false);
        alert(`Job Opened successfully`);
        // alert(`State Updated successfully`);
        console.log(`State Updated successfully`);
      } else {
        setisloading(false);
        console.error(`Error while saving State`);
        alert(`Error while saving State`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving State `, error);
      alert(`Error while saving State `, error);
    }
  }

  const handleTaskChange = (selectedOptions) => {
    const selectedValues = selectedOptions
      .map((option) => option.value)
      .filter((value) => value && value.trim() !== "");
    setSelTaskOP(selectedValues);
    setProblemsReportedOP(selectedValues.join(","));
  };

  const ExcelStockData = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Vehicles In Workshop Report");
    const rows = document.querySelectorAll(".table_1 tbody tr");

    const columnWidths = [15, 15, 15, 15, 15, 50];

    // Set column widths for the worksheet
    columnWidths.forEach((width, index) => {
      worksheet.getColumn(index + 1).width = width;
    });

    // Add headers
    const headerRow = worksheet.addRow([
      "JOB ID",
      "VEHICLE",
      "DATE",
      "TIME",
      "LOADED/EMPTY",
      "PROBLEMS REPORTED",
    ]);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
    });

    // Add rows from the table
    rows.forEach((row) => {
      const rowData = [];
      row.querySelectorAll("td").forEach((cell) => {
        rowData.push(cell.textContent);
      });
      worksheet.addRow(rowData);
    });

    // Create a blob from the workbook
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Vehicles_In_Workshop_Report.xlsx";
      link.click();
    });
  };

  const PdfStockData = () => {
    const doc = new jsPDF();

    doc.text("Vehicles In Workshop - Report", 10, 10);

    const columns = [
      "JOB ID",
      "VEHICLE",
      "DATE",
      "TIME",
      "LOADED/EMPTY",
      "PROBLEMS REPORTED",
    ];

    const data = filtHist.map((stock) => [
      stock.OT_JOB_ID,
      stock.OT_JOB_VEHICLE,
      stock.OT_JOB_OPEN_DATE
        ? moment(stock.OT_JOB_OPEN_DATE).format("DD/MM/YYYY")
        : "",
      stock.OT_JOB_OPEN_TIME
        ? moment(stock.OT_JOB_OPEN_TIME).format("hh:MM:ss")
        : "",
      stock.OT_JOB_TRUCK_LOADED_EMPTY,
      stock.OT_JOB_PROBLEMS_REPORTED,
    ]);

    doc.autoTable({
      head: [columns],
      body: data,
      startY: 20,
      showHead: "firstPage",
    });

    doc.save("Vehicles_In_Workshop_Report.pdf");
  };

  if (isloading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen p-1">
      <AllPagesNavbar />
      <div className="flex justify-between">
        <h1 className="lg:text-3xl font-extrabold underline text-blue-600">
          Vehicles In Workshop
        </h1>
      </div>

      <div className="select_product_type" style={{ marginTop: "5px" }}>
        <div>
          <p>Search</p>
        </div>
        <div>
          <input
            type="text"
            className="w-64 h-8 border border-black rounded-md"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          ></input>
        </div>
        <p className="lg:ml-2">Job Status :</p>
        <Select
          className="w-48 lg:ml-1"
          value={
            openedOrClosed
              ? { value: openedOrClosed, label: openedOrClosed }
              : { value: "", label: "Select Job Status" }
          }
          onChange={(e) => {
            setOpenedOrClosed(e.value);
          }}
          options={[
            { value: "", label: "Select job Status" },
            { value: "NOT OPENED", label: "NOT OPENED" },
            { value: "OPENED", label: "OPENED" },
          ]}
        ></Select>
        .
      </div>

      <div className="visible lg:h-[500px] p-1 z-0 lg:overflow-auto mt-2">
        <table className="w-full border border-gray-300 text-sm">
          <thead className="sticky top-0">
            <tr className="bg-[#2b3f5c] text-white text-[12px]">
              <td className="py-2 px-4 text-right border border-gray-300">
                SNO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                VEHICLE REG NO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                DRIVER NAME
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                MAKE
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                MODEL
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                TRAILER ATTACHED ?
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                ATTACHED NAME TRAILER
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                ACTIONS
              </td>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((value, index) => (
              <tr
                key={index}
                className={`${
                  value?.VEHICLESTATE === "JOB IN WORKSHOP"
                    ? "hover:bg-gray-600 bg-yellow-400"
                    : "hover:bg-gray-100"
                } text-[13px]`}
              >
                <td className="py-2 px-4 text-right border border-gray-300">
                  {index + 1}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["VEHICLE REG NO"] || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["DRIVERNAME"] || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.MAKE || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.MODEL || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["TRAILER ATTACHED"] === true
                    ? "YES"
                    : value["TRAILER ATTACHED"] === false
                      ? "NO"
                      : "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["TRAILER NAME ATTACHED"] || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value?.VEHICLESTATE === "JOB IN WORKSHOP" ? (
                    <button
                      className="lg:flex block my-1 h-[30px] items-center justify-center border border-black bg-[#002d62]  text-white rounded-md px-3 py-1 lg:ml-2 focus:outline-none focus:ring focus:border-blue-300"
                      onClick={() => {
                        handleRowClick(value, index);
                      }}
                    >
                      CLOSE JOB
                    </button>
                  ) : (
                    <button
                      className="lg:flex block my-1 h-[30px] items-center justify-center border border-black bg-[#002d62]  text-white rounded-md px-3 py-1 lg:ml-2 focus:outline-none focus:ring focus:border-blue-300"
                      onClick={() => {
                        handleRowClickOP(value, index);
                      }}
                    >
                      OPEN JOB
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Close Popup */}
      {showGateIn && (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border border-black lg:h-[550px] h-[80%] lg:w-[1050px] w-[95%] p-1 overflow-y-auto rounded-md">
          <h1 className="lg:text-3xl font-bold flex lg:justify-center justify-start">
            VEHICLES IN WORKSHOP
          </h1>

          {/* Row 1 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Job Id:</p>
            <input
              className="w-20 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={jobId}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-6">Vehicle:</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={vehicleNo}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-6">Job Open Date :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="date"
              value={jobOpenDate?.split("T")[0]}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-6">Job Open Time :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={jobOpenTime?.split("T")[1]?.split(".")[0]}
              readOnly
            ></input>
          </div>

          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Vehicle Loaded</p>
            <input
              className="w-4 h-4 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="checkbox"
              checked={isLoadedOrEmpty}
              readOnly
            ></input>
            <p className="text-red-600 lg:ml-2">Problem Reported :</p>
            <textarea
              rows={2}
              className="lg:w-64 w-[370px] resize-none border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={problemsReported}
              onChange={(e) => setProblemsReported(e.target.value)}
            ></textarea>
            <p className="text-red-600 lg:ml-2">Driver :</p>
            <Select
              className="lg:w-72 w-64 lg:ml-2"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
              value={
                driverName
                  ? { value: driverName, label: driverName }
                  : { value: "", label: "Select Driver" }
              }
              onChange={(e) => {
                setDriverName(e.label);
                // setDriverCode(e.value);
              }}
              options={[
                { value: "", label: "Select Driver" },
                ...driversList?.map((item) => ({
                  value: item.DRIVERNAME,
                  label: item.DRIVERNAME,
                })),
              ]}
            ></Select>
          </div>

          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Task Name :</p>
            <Select
              className="w-64 lg:ml-2"
              value={
                taskName
                  ? { value: taskName, label: taskName }
                  : { value: "", label: "Select Task" }
              }
              onChange={(e) => {
                if (e.value !== "") {
                  setTaskName(e.value);
                  const compliance = taskList.find(
                    (item) => item.OM_ACTION_NAME === e.value,
                  );
                  setTaskId(compliance?.OM_ACTION_ID);
                } else {
                  setTaskName("");
                }
              }}
              options={[
                { value: "", label: "Select Compliance" },
                ...taskList.map((item) => ({
                  label: item?.OM_ACTION_NAME,
                  value: item?.OM_ACTION_NAME,
                })),
              ]}
            ></Select>

            {/* <p className="text-red-600 lg:ml-2">Status :</p>
            <Select
              className="w-48 lg:ml-1"
              value={
                taskStatus
                  ? { value: taskStatus, label: taskStatus }
                  : { value: "", label: "Select Task Status" }
              }
              onChange={(e) => {
                setTaskStatus(e.value);
              }}
              options={[
                { value: "", label: "Select Task Status" },
                { value: "NOT STARTED", label: "NOT STARTED" },
                { value: "STARTED", label: "STARTED" },
                { value: "COMPLETED", label: "COMPLETED" },
              ]}
            ></Select> */}

            <p className="text-red-600 lg:ml-4">Proceed To :</p>
            <Select
              className="w-64 lg:ml-4"
              value={
                proceedToState
                  ? { value: proceedToState, label: proceedToState }
                  : { value: "", label: "Select Status" }
              }
              onChange={(e) => {
                setProceedToState(e.label);
                setProceedToStateValue(e.value);
              }}
              options={[
                { value: "", label: "Select Status" },
                {
                  label: "PROCEED TO LOAD",
                  value: "SENT TO LOAD",
                },
                {
                  value: "SENT FOR WEIGHBRIDGE",
                  label: "PROCEED TO WEIGHBRIDGE",
                },
                {
                  value: "DISPATCHED",
                  label: "PROCEED TO GATE OUT",
                },
              ]}
              isDisabled={isLoadedOrEmpty}
            ></Select>

            {/* <button
              className="lg:flex block my-1 h-[30px] items-center justify-center border border-black bg-[#002d62]  text-white rounded-md px-3 py-1 lg:ml-2 focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                AddItemsToGrid();
              }}
            >
              Add
            </button>

            <button
              className="lg:flex block my-1 h-[30px] items-center justify-center border border-black bg-[#002d62]  text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                RemoveItems();
              }}
            >
              Remove
            </button> */}
          </div>
          {proceedToState === "PROCEED TO WEIGHBRIDGE" && (
            <div className="lg:flex lg:flex-row mt-2">
              <p className="text-red-600 lg:ml-2">WeighBridge :</p>
              <Select
                className="lg:w-64 lg:ml-2"
                menuPortalTarget={document.body} // ⬅️ Renders dropdown at body level
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ⬅️ Forces on top
                }}
                value={
                  wbName
                    ? { value: wbName, label: wbName }
                    : { value: "", label: "Select WeighBridge" }
                }
                onChange={(e) => {
                  if (e.value !== "") {
                    setWbName(e.label);
                    setWbNo(e.value);
                    const weigh = WeighBridgeData?.filter(
                      (item) => item?.WEIGHBRIDGENO === e.value,
                    );
                    setNoOfVehicles(weigh?.length);
                  }
                }}
                options={[
                  { value: "", label: "Select WeighBridge" },
                  ...wbData?.map((item) => ({
                    value: item.WBNUMBER,
                    label: item.WBNAME,
                  })),
                ]}
              ></Select>
              <p className="text-red-600 lg:ml-2">No Of Vehicles :</p>
              <input
                className="w-20 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                type="number"
                value={noOfVehicles}
                readOnly
              ></input>
            </div>
          )}

          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Job Close Date :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="date"
              value={closeDate?.split("T")[0]}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-6">Job Close Time :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={closeTime}
              readOnly
            ></input>
          </div>
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Close Narration :</p>
            <textarea
              rows={2}
              className="lg:w-[700px] w-[370px] resize-none border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={closeNarration}
              onChange={(e) => setCloseNarration(e.target.value)}
            ></textarea>
          </div>

          <div className="lg:w-full h-auto p-1">
            {showTable && (
              <aside className="table__pos__app text-[14px] lg:w-[98%] ">
                <table className="w-full border border-gray-300 text-sm">
                  <thead className="sticky top-0">
                    <tr className="bg-[#2b3f5c] text-white text-[12px]">
                      <td className="py-2 px-4 text-right border border-gray-300">
                        Task Id
                      </td>
                      <td className="py-2 px-4 text-left border border-gray-300">
                        Task Name
                      </td>
                      <td className="py-2 px-4 text-left border border-gray-300">
                        Status
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {jobTasksList.map((value, index) => {
                      const task = taskList.find(
                        (item) => item.OM_ACTION_ID === value?.OT_JOB_TASK_ID,
                      );
                      const taskName = task?.OM_ACTION_NAME;
                      return (
                        <tr
                          className="hover:bg-gray-100 cursor-pointer text-[13px]"
                          onClick={() => {
                            setTaskId(value?.OT_JOB_TASK_ID);
                            setTaskName(taskName);
                            setTaskStatus(value?.OT_JOB_TASK_STATUS);
                          }}
                        >
                          <td className="py-2 px-4 text-right border border-gray-300">
                            {value.OT_JOB_TASK_ID ? value.OT_JOB_TASK_ID : ""}
                          </td>
                          <td className="py-2 px-4 text-left border border-gray-300">
                            {taskName ? taskName : ""}
                          </td>
                          <td className="py-2 px-4 text-left border border-gray-300">
                            {value.OT_JOB_TASK_STATUS
                              ? value.OT_JOB_TASK_STATUS
                              : ""}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </aside>
            )}
          </div>

          <button
            className="absolute top-2 right-20 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={async () => {
              if (!jobId) {
                alert("Kindly supply Job Id");
                return;
              } else if (!proceedToState) {
                alert("Kindly supply Proceed To");
                return;
              } else if (!closeNarration) {
                alert("Kindly Supply Close Narration");
                return;
              } else {
                await SaveGateIn();
                setShowGateIn(false);
                window.location.reload();
              }
            }}
          >
            CLOSE JOB
          </button>

          <button
            className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => setShowGateIn(false)}
          >
            Close
          </button>
        </div>
      )}

      {showClosePopUp && (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border border-black lg:h-[200px] h-[80%] lg:w-[1000px] w-[95%] p-1 overflow-y-auto rounded-md">
          <h1 className="lg:text-3xl font-bold flex lg:justify-center justify-start">
            CLOSE JOB
          </h1>
          {/* Row 1 */}

          <button
            className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => setShowClosePopUp(false)}
          >
            Close
          </button>
        </div>
      )}

      {/* JOBS OPEN */}

      {showGateInOP && (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border border-black lg:h-[400px] h-[80%] lg:w-[1000px] w-[95%] p-1 overflow-y-auto rounded-md">
          <h1 className="lg:text-3xl font-bold flex lg:justify-center justify-start">
            VEHICLES IN WORKSHOP
          </h1>

          {/* Row 1 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Job Id:</p>
            <input
              className="w-20 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={jobIdOP}
              readOnly
            ></input>

            <button
              className="border border-black bg-[#002d62] text-white rounded-md px-3  lg:ml-1 mr-1 h-7 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                setShowhist(true);
              }}
            >
              ...
            </button>

            {showHist && (
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[600] bg-white border border-black lg:h-[300px] h-[80%] lg:w-[900px] w-[95%] p-1 overflow-y-auto">
                <div className="lg:flex lg:flex-row mt-2">
                  <p className="text-red-600 lg:ml-2">Search:</p>
                  <input
                    className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="text"
                    value={searchHist}
                    onChange={(e) => {
                      setSearchHist(e.target.value);
                    }}
                  ></input>
                  <p className="text-red-600 lg:ml-2">Start Date:</p>
                  <input
                    className="w-36 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="date"
                    value={startDateHist?.split("T")[0]}
                    onChange={(e) => {
                      setStartDateHist(e.target.value);
                    }}
                  ></input>
                  <p className="text-red-600 lg:ml-2">End Date:</p>
                  <input
                    className="w-36 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="date"
                    value={endDateHist?.split("T")[0]}
                    onChange={(e) => {
                      setEndDateHist(e.target.value);
                    }}
                  ></input>
                </div>
                <button
                  className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => setShowhist(false)}
                >
                  Close
                </button>
                <div className="visible lg:h-[220px] p-1 z-0 lg:overflow-auto mt-2">
                  <div className="flex justify-end gap-2">
                    <div className="cursor-pointer">
                      <RiFileExcel2Line onClick={ExcelStockData} size={25} />
                    </div>
                    <div className="cursor-pointer">
                      <BsFileEarmarkPdf onClick={PdfStockData} size={25} />
                    </div>
                  </div>

                  <table className="w-full border border-gray-300 text-sm table_1">
                    <thead className="sticky top-0">
                      <tr className="bg-[#2b3f5c] text-white text-[12px] table-header">
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Job Id
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Vehicle
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Date
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Time
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Empty/Loaded
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Problem Reported
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {filtHist?.map((item, index) => {
                        return (
                          <tr
                            className="hover:bg-gray-100 cursor-pointer text-[13px]"
                            onClick={() => {
                              setJobIdOP(item?.["OT_JOB_ID"]);
                              setVehicleNoOP(item?.["OT_JOB_VEHICLE"]);
                              setJobOpenDateOP(item?.["OT_JOB_OPEN_DATE"]);
                              setJobOpenTimeOP(item?.["OT_JOB_OPEN_TIME"]);
                              setLoadedOrEmpty(
                                item?.["OT_JOB_TRUCK_LOADED_EMPTY"],
                              );
                              setProblemsReportedOP(
                                item?.["OT_JOB_PROBLEMS_REPORTED"],
                              );
                              setHist(true);
                              setShowhist(false);
                            }}
                            key={index}
                          >
                            <td className="py-2 px-4 text-right border border-gray-300">
                              {item?.["OT_JOB_ID"] ? item?.["OT_JOB_ID"] : "NA"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {item?.["OT_JOB_VEHICLE"]
                                ? item?.["OT_JOB_VEHICLE"]
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {item?.["OT_JOB_OPEN_DATE"]
                                ? moment(item?.["OT_JOB_OPEN_DATE"]).format(
                                    "DD/MM/YYYY",
                                  )
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {item?.["OT_JOB_OPEN_TIME"]
                                ? moment(item?.["OT_JOB_OPEN_TIME"]).format(
                                    "hh:MM:ss",
                                  )
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 text-right border border-gray-300">
                              {item?.["OT_JOB_TRUCK_LOADED_EMPTY"]
                                ? item?.["OT_JOB_TRUCK_LOADED_EMPTY"]
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 border border-gray-300">
                              {item?.["OT_JOB_PROBLEMS_REPORTED"]
                                ? item?.["OT_JOB_PROBLEMS_REPORTED"]
                                : "NA"}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            <p className="text-red-600 lg:ml-6">Vehicle:</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={vehicleNoOP}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-6">Job Open Date :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="date"
              value={jobOpenDateOP?.split("T")[0]}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-6">Job Open Time :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={jobOpenTimeOP}
              readOnly
            ></input>
          </div>

          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Empty/Loaded :</p>
            <Select
              className="w-40 lg:ml-1"
              value={
                loadedOrEmpty
                  ? { value: loadedOrEmpty, label: loadedOrEmpty }
                  : { value: "", label: "Select Empty/Loaded" }
              }
              onChange={(e) => {
                setLoadedOrEmpty(e.value);
              }}
              options={[
                { value: "", label: "Select Empty/Loaded" },
                { value: "EMPTY", label: "EMPTY" },
                { value: "LOADED", label: "LOADED" },
              ]}
            ></Select>
            <p className="text-red-600 lg:ml-2">Driver :</p>
            <Select
              className="lg:w-52 w-64 lg:ml-2"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
              value={
                driverNameOP
                  ? { value: driverNameOP, label: driverNameOP }
                  : { value: "", label: "Select Driver" }
              }
              onChange={(e) => {
                setDriverNameOP(e.label);
                // setDriverCode(e.value);
              }}
              options={[
                { value: "", label: "Select Driver" },
                ...driversListOP?.map((item) => ({
                  value: item.DRIVERNAME,
                  label: item.DRIVERNAME,
                })),
              ]}
            ></Select>
            <p className="text-red-600 lg:ml-2">Problem Reported :</p>
            <textarea
              rows={2}
              className="lg:w-64 w-[370px] resize-none border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={problemsReportedOP}
              onChange={(e) => setProblemsReportedOP(e.target.value)}
            ></textarea>
          </div>
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Gate In Narration :</p>
            <textarea
              rows={2}
              className="lg:w-96 resize-none border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={gateInNarration}
            ></textarea>
          </div>

          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Task Name :</p>
            <Select
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
              className="w-96 lg:ml-2"
              isMulti
              options={[
                { value: "", label: "Select Destination" },
                ...taskOptions,
              ]}
              onChange={handleTaskChange}
              value={taskOptions.filter((option) =>
                selTaskOP.includes(option.value),
              )}

              // value={
              //   taskNameOP
              //     ? { value: taskNameOP, label: taskNameOP }
              //     : { value: "", label: "Select Task" }
              // }
              // onChange={(e) => {
              //   if (e.value !== "") {
              //     setTaskNameOP(e.value);
              //     const compliance = taskListOP.find(
              //       (item) => item.OM_ACTION_NAME === e.value,
              //     );
              //     setTaskIdOP(compliance?.OM_ACTION_ID);
              //   } else {
              //     setTaskNameOP("");
              //   }
              // }}
              // options={[
              //   { value: "", label: "Select Compliance" },
              //   ...taskListOP.map((item) => ({
              //     label: item?.OM_ACTION_NAME,
              //     value: item?.OM_ACTION_NAME,
              //   })),
              // ]}
            ></Select>

            {/* <p className="text-red-600 lg:ml-2">Status :</p>
            <Select
              className="w-64 lg:ml-1"
              value={
                taskStatusOP
                  ? { value: taskStatusOP, label: taskStatusOP }
                  : { value: "", label: "Select Task Status" }
              }
              onChange={(e) => {
                setTaskStatusOP(e.value);
              }}
              options={[
                { value: "", label: "Select Task Status" },
                { value: "NOT STARTED", label: "NOT STARTED" },
                { value: "STARTED", label: "STARTED" },
                { value: "COMPLETED", label: "COMPLETED" },
              ]}
            ></Select> */}
            {/* <button
              className="lg:flex block my-1 h-[30px] items-center justify-center border border-black bg-[#002d62]  text-white rounded-md px-3 py-1 lg:ml-2 focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                AddItemsToGridOP();
              }}
            >
              Add
            </button>

            <button
              className="lg:flex block my-1 h-[30px] items-center justify-center border border-black bg-[#002d62]  text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                RemoveItemsOP();
              }}
            >
              Remove
            </button> */}
          </div>

          <div className="lg:w-full h-auto p-1">
            {showTableOP && (
              <aside className="table__pos__app text-[14px] lg:w-[98%] ">
                <table className="w-full border border-gray-300 text-sm">
                  <thead className="sticky top-0">
                    <tr className="bg-[#2b3f5c] text-white text-[12px]">
                      <td className="py-2 px-4 text-right border border-gray-300">
                        Task Id
                      </td>
                      <td className="py-2 px-4 text-left border border-gray-300">
                        Task Name
                      </td>
                      <td className="py-2 px-4 text-left border border-gray-300">
                        Status
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {jobTasksListOP.map((value, index) => (
                      <tr
                        className="hover:bg-gray-100 cursor-pointer text-[13px]"
                        onClick={() => {
                          setTaskIdOP(value?.OT_JOB_TASK_ID);
                          setTaskNameOP(value?.OT_JOB_TASK_NAME);
                          setTaskStatusOP(value?.OT_JOB_TASK_STATUS);
                        }}
                      >
                        <td className="py-2 px-4 text-right border border-gray-300">
                          {value.OT_JOB_TASK_ID ? value.OT_JOB_TASK_ID : ""}
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          {value.OT_JOB_TASK_NAME ? value.OT_JOB_TASK_NAME : ""}
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          {value.OT_JOB_TASK_STATUS
                            ? value.OT_JOB_TASK_STATUS
                            : ""}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </aside>
            )}
          </div>

          <button
            className="absolute top-2 right-20 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={async () => {
              if (!loadedOrEmpty) {
                alert("Kindly Supply Loaded/Empty");
                return;
              } else if (!driverNameOP) {
                alert("Kindly Supply Driver");
                return;
              } else if (selTaskOP.length === 0) {
                alert("Kindly Select the tasks");
                return;
              } else if (!problemsReportedOP) {
                alert("Kindly Supply Problem Reported");
                return;
              } else {
                await SaveGateInOP();
                setShowGateInOP(false);
                window.location.reload();
              }
            }}
          >
            SAVE
          </button>

          <button
            className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => setShowGateInOP(false)}
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
};

export default VehiclesInWorkshopAndJobsOpen;
